module.exports = __webpack_public_path__ + "static/media/AB_P7_9.c6a041fc.jpg";